import styled from "@emotion/styled";
import { Grid, Tooltip } from "@mui/material";
import { globalColors } from "../../Utils/colors";

export const ExtraHeaderText = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin: 15px 0px;
`;

export const HeaderText = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin: 10px 0px;
`;

export const ErrorText = styled.div`
  color: red;
  font-size: 11px;
`;

export const FormSettingsContainer = styled(Grid)`
  align-items: center;
  display: flex;
  margin-bottom: 15px;
`;

export const BackgroundSettingsContainer = styled(Grid)`
  align-items: center;
  display: flex;
  margin-bottom: 15px;
`;

export const LandingPageSettingsContainer = styled(Grid)`
  align-items: center;
  display: flex;
  margin-bottom: 15px;
`;

export const BasicSettingsContainer = styled(Grid)`
  align-items: center;
  display: flex;
  margin-bottom: 15px;
`;

export const GeneralSettingsContainer = styled(Grid)`
  align-items: center;
  display: flex;
  margin-bottom: 15px;
`;

export const MainGridContainer = styled(Grid)`
  display: flex;
`;

export const LabelTextContainer = styled(Grid)`
  display: flex;
  align-items: center;
`;

export const TextContainer = styled("div")({
  fontFamily: "Poppins",
  fontSize: "14px",
});

export const TemplateRootContainer = styled("div")({
  fontFamily: "Poppins",
  height: "100%",
  overflow: "hidden",
});

export const TemplateActionContainer = styled(Grid)({
  height: "70px",
});

export const TemplateActionGridItem = styled(Grid)({
  alignItems: "center",
  display: "flex",
});

export const TemplateLabelContainer = styled("div")({
  fontFamily: "Poppins",
  fontSize: "14px",
  marginRight: "15px",
});

export const TemplateListContainer = styled("div")({
  height: "calc(100% - 70px)",
  overflowY: "auto",
});

export const TemplateListGridContainer = styled("div")`
  border-radius: 20px;
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  padding-top: 15px;
  padding-bottom: 15px;
  padding-right: 10px;
`;

export const TemplateListEmptyContainer = styled(Grid)`
  align-items: center;
  color: ${globalColors.textGrey};
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-family: "Poppins";
  height: 100%;
  justify-content: center;
`;

export const CustomToolTip = styled(Tooltip)`
  cursor: pointer;
`;

export const FlexDiv = styled("div")`
  display: flex;
  gap: 10px;
  margin: 10px 0px;
`;
